import { type FunctionComponent } from 'react';
import { useUniversalNavigationContext } from '@fff-web/fff-global-nav';
import env from '../../config/env';
import { usePersonalSurveyContext } from '../../contexts/PersonalSurveyContext';
import Survey from '../survey/Survey';

type Props = {
  welcomeText: string;
};

const PersonalSurvey: FunctionComponent<Props> = ({ welcomeText }) => {
  const { hasNMCAccess } = usePersonalSurveyContext();
  const { timerLoading, timer } = useUniversalNavigationContext();
  const { timerSource, timerType } = timer ?? {};
  const isFMCFlow = timerSource === 'introProduct' || timerSource === 'publicCustomize';
  const isNewMember = timerType === 'NEW_MEMBER' || timerType === 'REACTIVATION';
  const skipCustomize = isFMCFlow || !hasNMCAccess;

  const afterLastButton = () => {
    // if user is in FMC Flow or IntroProduct or has a public subscription (is club tier)
    // redirect to home instead of new-member-customize
    if (skipCustomize) {
      return window.location.assign(env.SITE_URL);
    }
    return window.location.assign(`${env.SITE_URL}/new-member-customize`);
  };

  if (timerLoading) return null;

  return (
    <Survey
      welcomeText={welcomeText}
      afterLastButton={afterLastButton}
      shouldStopTimer={skipCustomize}
      isNewMember={isNewMember}
    />
  );
};

export default PersonalSurvey;
